import { Listing } from './types/Listing';
import { MakeCall } from './createMakeCall';

export type CreateListingPayload = Pick<
  Listing,
  | 'address'
  | 'currency'
  | 'kind'
  | 'price'
  | 'type'
  | 'minimumStayMonths'
  | 'isCharitable'
  | 'maximumStay'
>;

const createListing =
  (makeCall: MakeCall) =>
  ({
    address,
    currency,
    isCharitable,
    kind,
    maximumStay,
    minimumStayMonths,
    price,
    type,
  }: CreateListingPayload) =>
    makeCall<Listing>('POST', `/api/v2/listing`, {
      data: {
        address,
        currency,
        isCharitable,
        kind,
        maximumStay,
        minimumStayMonths,
        price,
        type,
      },
    });
export { createListing };
